//React
import React, { useEffect } from "react";
//Components
import { Button, FlexBox, Image, Screen } from "components";
//Styles
import "./styles.scss";
//Assets
import ProductHunt from "assets/producthunt.svg";
import PartyGif from "assets/party.gif";
import PoweredByOTPless from "assets/PoweredByOTPless.png";
import { ChangeHistory, EventManager, EventNames } from "utils";
import ROUTE_PATH from "Routes/paths";
const Demo = () => {
  //Return UI
  return (
    <Screen className="ProductHunt-screen pd-20">
      {/* <iframe src="https://mihit.authlink.me/getdata.html"></iframe> */}
      <FlexBox flexColumn justifyBetween alignCenter className="h-100">
        <div className="text-center">
          <p className="clr-theme font-extra-heavy fs-36">WhatsApp Login</p>
          <p className="font-heavy fs-32">is live on</p>
          <Image src={ProductHunt} className="mr-t-40 w-50 mr-b-20" />
          <Image src={PartyGif} className="w-30 dsp-b mr-au" />
        </div>
        <FlexBox flexColumn alignCenter>
          <Button
            className="w-100 fs-18 mr-b-40 pd-15"
            text={"Login with WhatsApp"}
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.PRODUCT_HUNT
                  .LOGIN_WITH_WHATSAPP_CLICK
              );
              const path = "https://producthunt.authlink.me";
              const url = window.location.href; //"https://otpless.com?n=1&w=2&y=3&z=4"
              const breakUrl = url.split("?"); //["https://otpless.com", "n=1&w=2&y=3&w=4"]
              const queryParams = breakUrl[1]; // "n=1&w=2&y=3&w=4"
              const hasQueryParams = breakUrl.length > 1;
              const finalUrl = hasQueryParams
                ? `${path}?${queryParams}` // `${orgData.data.orgAuthlink}/getting-started?n=1&w=2&y=3&w=4`
                : path ?? "";
              window.open(finalUrl, "_self");
            }}
          />
          <Image
            src={PoweredByOTPless}
            className="w-45 clicking-animation"
            onClick={() => {
              EventManager.send(
                EventNames.EVENTS_NAME.WEBSITE.PRODUCT_HUNT.GO_OTPLESS_CLICK
              );
              ChangeHistory("push", ROUTE_PATH.SAMPLES.LANDING);
            }}
          />
        </FlexBox>
      </FlexBox>
    </Screen>
  );
};

export default Demo;
